var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleMaps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.029 64.2243C42.6875 66.3251 44.1969 68.538 45.5463 70.8471C46.6985 73.0188 47.1787 74.4913 48.0209 77.1079C48.5372 78.5535 49.0039 78.9849 50.0073 78.9849C51.1008 78.9849 51.5969 78.2509 51.9802 77.1157C52.7761 74.6448 53.4006 72.7588 54.386 70.9771C56.3194 67.5368 58.7218 64.4798 61.0825 61.5416C61.7217 60.7101 65.8535 55.8657 67.7136 52.0434C67.7136 52.0434 69.9999 47.8445 69.9999 41.9803C69.9999 36.495 67.7452 32.6906 67.7452 32.6906L61.2538 34.4185L57.3115 44.7393L56.3363 46.1624L56.1413 46.4202L55.882 46.7429L55.4265 47.2584L54.776 47.905L51.2654 50.7479L42.4889 55.785L41.029 64.2243Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9706 51.3374C34.1126 56.2008 38.2433 60.4759 41.038 64.2277L55.882 46.7496C55.882 46.7496 53.7907 49.4682 49.9971 49.4682C45.7718 49.4682 42.3581 46.1143 42.3581 41.8851C42.3581 38.985 44.1134 36.9926 44.1134 36.9926L34.0371 39.6764L31.9706 51.3374Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0477 22.8987C60.9776 24.4788 65.1973 27.7957 67.7497 32.6872L55.8865 46.7395C55.8865 46.7395 57.6418 44.7112 57.6418 41.8291C57.6418 37.5013 53.9756 34.2683 50.0152 34.2683C46.2701 34.2683 44.1191 36.9824 44.1191 36.9824V28.1297L56.0477 22.8987Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6898 29.108C37.6345 25.6061 42.8158 22 49.9588 22C53.4243 22 56.0353 22.9043 56.0353 22.9043L44.1078 36.9903H35.6571L34.6898 29.108Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9706 51.3374C31.9706 51.3374 30 47.5015 30 41.9445C30 36.6922 32.0541 32.1011 34.6898 29.108L44.1146 36.9914L31.9706 51.3374Z",
    fill: "#EA4335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/GoogleMaps.41fe61717729723cf46591df766d7a24.svg";
export { ForwardRef as ReactComponent };